import { DataIdConverterFactory } from 'src/app/core/services/mapper/data-id.converter';
import { Cahier } from '../../habilitation/models/cahier.model';
import { Produit } from '../../habilitation/models/produit.model';
import { PointAMaitriser } from './point-a-maitriser.model';
import { ManquementConstate } from './manquement-constate.model';
import { IntensiteDefaut } from './enums/intensite-defaut.enum';
import { Gravite } from './enums/gravite.enum';
import { Sanction } from './sanction.model';
import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';
import { Animateur } from '../../commission/models/animateur.model';
import { Defaut } from '../../commission/models/defaut.model';

export class Constat {
    static jsonMap = {
        cahierDesCharges: { key: 'idCahier', converter: new (DataIdConverterFactory.build(Cahier, 'cahiers'))() },
        codeProduit: 'codeProduit',
        idPointAMaitriser: 'idPointMaitrise',
        idManquementConstate: 'idManquementConstate',
        intensite: 'intensite',
        gravite: 'gravite',
        idSanctionEncourue: 'idSanctionEncourue',
        date: { key: 'dateConstat', converter: new DateConverter() },
        auteur: { key: 'idAuteurConstat', converter: new (DataIdConverterFactory.build(Animateur, 'agents'))() },
        commentaire: 'commentaire',
        idsDefauts: 'idsDefauts'
    };

    cahierDesCharges: Cahier;

    codeProduit: string;
    produit: Produit;

    idPointAMaitriser: number;
    pointAMaitriser: PointAMaitriser;

    idManquementConstate: number;
    manquementConstate: ManquementConstate;

    intensite: IntensiteDefaut = IntensiteDefaut.MOYENNE;

    gravite: Gravite = Gravite.MAJEURE;

    idSanctionEncourue: number;
    sanctionEncourue: Sanction;

    date: moment.Moment;

    auteur: Animateur;

    commentaire: string;

    idsDefauts: number[] = [];
    defauts: Defaut[] = [];
}
